/* ASC-CUSTOM: analytics bridge.
   asc.track(name, params, opts) -> Shopify.analytics.publish('asc_<name>', params)
   Custom pixels (Settings > Customer events) receive the event via analytics.subscribe('asc_<name>').
   Mirrors the event name to Microsoft Clarity when window.clarity exists.
   Never pass personalization text (names, dates, notes): only booleans / option labels / counts. */
(function () {
  'use strict';
  if (window.asc && window.asc.track) return;
  var asc = window.asc = window.asc || {};
  var queue = [], seen = Object.create(null), tries = 0, timer = null;
  var debug = false;
  try { debug = localStorage.getItem('asc_debug') === '1'; } catch (e) {}

  function pageType() {
    var m = /template-([a-z0-9-]+)/.exec(document.body.className || '');
    return m ? m[1] : '';
  }
  function handle() {
    var m = /\/(products|collections)\/([^/?#]+)/.exec(location.pathname);
    return m ? m[2] : '';
  }
  function device() {
    try { return matchMedia('(hover: hover) and (pointer: fine)').matches ? 'pointer' : 'touch'; } catch (e) { return ''; }
  }
  function clean(p) {
    var out = {}, k, v;
    p = p || {};
    for (k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      v = p[k];
      if (v === null || v === undefined || typeof v === 'object' || typeof v === 'function') continue;
      out[String(k).slice(0, 40)] = typeof v === 'string' ? v.slice(0, 100) : v;
    }
    out.page_type = pageType();
    if (!out.handle) out.handle = handle();
    out.device = device();
    return out;
  }
  function ready() {
    return !!(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function');
  }
  function publish(name, p) {
    try { window.Shopify.analytics.publish(name, p); return true; } catch (e) { return false; }
  }
  function flush() {
    if (!ready()) { if (++tries > 80) { clearInterval(timer); timer = null; } return; }
    var q = queue.splice(0); q.forEach(function (i) { publish(i[0], i[1]); });
    if (!queue.length && timer) { clearInterval(timer); timer = null; }
  }

  asc.track = function (name, params, opts) {
    opts = opts || {};
    name = 'asc_' + String(name || '').replace(/^asc_/, '').replace(/[^a-z0-9_]/gi, '_').toLowerCase().slice(0, 36);
    if (opts.once) {
      var key = name + '|' + (opts.once === true ? '' : String(opts.once));
      if (seen[key]) return; seen[key] = 1;
    }
    var p = clean(params);
    if (ready()) publish(name, p); else { queue.push([name, p]); if (!timer) timer = setInterval(flush, 250); }
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (opts.tag && p[opts.tag] !== undefined) window.clarity('set', opts.tag, String(p[opts.tag]));
      }
    } catch (e) {}
    if (debug) { try { console.log('[asc.track]', name, p); } catch (e) {} }
  };
  asc.handleOf = function (el) {
    var a = el && (el.matches && el.matches('a[href*="/products/"]') ? el : el.querySelector && el.querySelector('a[href*="/products/"]'));
    var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : '';
  };
})();
